var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.person.latestLicenceYear)?_c(_setup.AppChip,{attrs:{"color":_setup.chipColor,"class-list":"white--text"}},[_vm._v(_vm._s(_setup.person.latestLicenceYear))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }